import script from "./ShopList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopList.vue?vue&type=script&setup=true&lang=js"

import "./ShopList.vue?vue&type=style&index=0&id=b0420666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0420666"]])

export default __exports__